export const rooQrPortfolioItem = {
  id: 'fallback-rooqr',
  title: 'RooQR',
  description: 'An Australian QR code studio for creating customizable static and dynamic QR codes, link-in-bio pages, branded designs, print-ready downloads, and scan analytics for businesses and creators.',
  category: 'Tools & Utilities',
  subcategory: 'QR Code Studio',
  type: 'marketing-tool',
  url: 'https://rooqr.com/',
  featured: 'TRUE',
  order: -2
};